import { cn } from '@utima/ui';
import { ChevronDown, ChevronUp } from 'lucide-preact';
import { useState, type ReactNode } from 'preact/compat';

type Props = {
  children: ReactNode;
  className?: string;
  title?: string;
  defaultOpen?: boolean;
};

export function Wrapper({
  children,
  title,
  className,
  defaultOpen = false,
}: Props) {
  const [isOpen, setIsOpen] = useState(defaultOpen || !title);

  return (
    <div
      className={cn(
        'flex flex-col gap-3.5 rounded-2xl border border-white bg-white/80 backdrop-blur-2xl p-4',
        className,
      )}
    >
      {title && (
        <div
          role='button'
          className='flex cursor-pointer items-center justify-between text-[#18181b] transition-colors hover:text-[#71717b]'
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className='text-sm font-medium'>{title}</span>
          <button
            data-cta='web-input-wrapper-toggle-button'
            className='rounded-lg p-1 text-[#71717a] transition-colors hover:bg-[#f4f4f5] hover:text-[#18181b]'
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              setIsOpen(!isOpen);
            }}
            type='button'
          >
            {isOpen ? (
              <ChevronUp className='size-4' />
            ) : (
              <ChevronDown className='size-4' />
            )}
          </button>
        </div>
      )}
      {isOpen && children}
    </div>
  );
}
